import React, { useCallback, useState } from "react";
import { Box, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { HELP_ICON } from "../../../../constants/icons/HelpIcon";
import HelpDrawer from "../../../campaign-creation/bottomPanel/HelpDrawer";
import { IFaqDetails } from "../../../../types/campaign.types";

interface IProps {
  stepNumber: number;
  faqData: IFaqDetails[];
  handleSaveAsDraft: () => void;
  handleSaveAndContinue?: () => void;
  handleStartCampaign?: () => void;
  isSaveAndContinueLoading?: boolean;
  isSaveAsDraftLoading?: boolean;
  isStartCampaignLoading?: boolean;
  isSaveAndContinueDisabled?: boolean;
}

const CampaignSetupButton: React.FC<IProps> = ({
  stepNumber,
  faqData,
  handleSaveAsDraft,
  handleSaveAndContinue,
  handleStartCampaign,
  isStartCampaignLoading,
  isSaveAndContinueLoading,
  isSaveAsDraftLoading,
  isSaveAndContinueDisabled,
}) => {
  const [showHelpDrawer, setShowHelpDrawer] = useState<boolean>(false);

  const handleOpenHelpDrawer = () => {
    setShowHelpDrawer(true);
  };

  const handleCloseHelpDrawer = useCallback(() => {
    setShowHelpDrawer(false);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 2,
        }}
      >
        <Button
          startIcon={HELP_ICON}
          onClick={handleOpenHelpDrawer}
          sx={{ textTransform: "none", color: "inherit" }}
        >
          Help
        </Button>
        <Box>
          <LoadingButton
            size="small"
            loading={isSaveAsDraftLoading}
            loadingPosition="start"
            sx={{ textTransform: "none" }}
            startIcon={
              <span
                style={{ paddingLeft: isSaveAsDraftLoading ? "10px" : 0 }}
              />
            }
            onClick={handleSaveAsDraft}
            disabled={isSaveAndContinueLoading || isStartCampaignLoading}
          >
            Save as draft
          </LoadingButton>
          <LoadingButton
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
            loading={
              stepNumber === 0
                ? isSaveAndContinueLoading
                : isStartCampaignLoading
            }
            loadingPosition="start"
            onClick={
              stepNumber === 0 ? handleSaveAndContinue : handleStartCampaign
            }
            disabled={
              isSaveAsDraftLoading ||
              (stepNumber === 0 ? isSaveAndContinueDisabled : false)
            }
            startIcon={
              <span
                style={{
                  paddingLeft: (
                    stepNumber === 0
                      ? isSaveAndContinueLoading
                      : isStartCampaignLoading
                  )
                    ? "15px"
                    : 0,
                }}
              />
            }
          >
            {stepNumber === 0 ? `Save & continue` : `Send Campaign`}
          </LoadingButton>
        </Box>
      </Box>
      <HelpDrawer
        showModal={showHelpDrawer}
        closeModal={handleCloseHelpDrawer}
        data={faqData}
      />
    </>
  );
};

export default CampaignSetupButton;
